import { render } from "./StartPanden.vue?vue&type=template&id=58635af6&scoped=true"
import script from "./StartPanden.vue?vue&type=script&lang=js"
export * from "./StartPanden.vue?vue&type=script&lang=js"

import "./StartPanden.vue?vue&type=style&index=0&id=58635af6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58635af6"]])

export default __exports__